import type { ReactNode } from "react";

import style from "./style.module.scss";

interface AdminPageProps {
  title?: string;
  children: ReactNode;
}

function AdminPage({ title, children }: AdminPageProps) {
  return (
    <div className={style.container}>
      {title && (
        <div className={style.header}>
          <h1 className={style.pageTitle}>{title}</h1>
        </div>
      )}
      <div className={style.content}>{children}</div>
    </div>
  );
}

export default AdminPage;
